@for (tab of display().tabs; track tab.path) {
<p-ai-chat-draft-table [tab]="tab"></p-ai-chat-draft-table>
}
